(function () {
    'use strict';
    angular.module('app').directive('selectioncommandrename', selectioncommand_rename);
    function selectioncommand_rename() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                renameDialogShown: '=?'
            },
            controller: 'rename',
            templateUrl: 'app/selectioncommand/selectioncommand_rename.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();